import { render, staticRenderFns } from "./default.vue?vue&type=template&id=31844358&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DelayHydration: require('/opt/build/repo/node_modules/nuxt-delay-hydration/dist/runtime/components/DelayHydration.vue').default})
